import { useState } from "react";
import { useAuth } from "@features/auth/AuthContext";
import { useLogout } from "@features/auth/queries";
import { ChangePasswordDialog } from "@features/auth/ChangePasswordDialog";
import { useLocation } from "react-router-dom";

const TITLES: Record<string, string> = {
  "/dashboard":   "Dashboard",
  "/pendientes":  "Pacientes Pendientes",
  "/nueva":       "Nueva Valoración",
  "/historial":   "Historial de Valoraciones",
  "/carga":       "Carga de Pacientes",
  "/indicadores": "Indicadores",
  "/informes":    "Informes",
  "/usuarios":    "Gestión de Usuarios",
  "/auditoria":   "Auditoría",
};

type Props = {
  onToggleSidebar: () => void;
};

export function Topbar({ onToggleSidebar }: Props) {
  const { user } = useAuth();
  const logout = useLogout();
  const location = useLocation();
  const [pwOpen, setPwOpen] = useState(false);
  const title = TITLES[location.pathname] || "Sistema de Valoración";

  if (!user) return null;

  return (
    <div id="topbar">
      <div className="topbar-left">
        <button id="btnMenuToggle" onClick={onToggleSidebar} aria-label="Menú" type="button">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className="topbar-title" id="topbarTitle">
          {title}
        </div>
      </div>
      <div className="topbar-right">
        {user.tempPassword === "Si" && (
          <span className="badge badge-warn" title="Debes cambiar tu contraseña temporal">
            ⚠️ Clave temporal
          </span>
        )}
        <span className="badge badge-blue" id="topRoleBadge">{user.role}</span>
        <span className="badge badge-gray" id="topUserBadge">{user.email || user.username}</span>
        <button
          type="button"
          onClick={() => setPwOpen(true)}
          className="topbar-btn topbar-btn--neutral"
        >
          🔑 <span className="topbar-btn-text">Cambiar contraseña</span>
        </button>
        <button
          type="button"
          onClick={() => logout.mutate()}
          disabled={logout.isPending}
          className="topbar-btn topbar-btn--danger"
        >
          🚪 <span className="topbar-btn-text">{logout.isPending ? "Saliendo…" : "Cerrar sesión"}</span>
        </button>
      </div>

      <ChangePasswordDialog open={pwOpen} onClose={() => setPwOpen(false)} />
    </div>
  );
}
